import { ERROR_CODES } from 'constants/errors';

const GENERAL_ERROR_KEY = 'generalError';

export const extractLetters = (code: string) => code.match(/[a-zA-Z]+/g)?.join('') || '';

export const spliceErrorCode = (errorCode: string) => {
    return errorCode?.split('.')[0];
};

export const getEntityName = (code: string) => {
    const lettersOnlyCode = extractLetters(code);
    switch (lettersOnlyCode) {
        case 'A':
            return 'auth';
        case 'U':
            return 'accounts';
        case 'P':
            return 'products';
        case 'PR':
            return 'productCategories';
        case 'NP':
            return 'nestedProducts';
        case 'NPC':
            return 'nestedProductCategories';
        case 'PL':
            return 'place';
        case 'T':
            return 'terminal';
        case 'C':
            return 'company';
        case 'W':
            return 'website';
        case 'PRM':
            return 'promotion';
        case 'G':
            return 'general';
        case 'CO':
            return 'companyOwner';
        default:
            return 'general';
    }
};

export const normalizeErrorCode = (code: string) => {
    if (!code) return GENERAL_ERROR_KEY;

    const splicedCode = spliceErrorCode(code);
    const entityName = getEntityName(splicedCode);
    const translationKey = ERROR_CODES[entityName][splicedCode] as string;

    return `${entityName}.${translationKey || GENERAL_ERROR_KEY}`;
};
